import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    SimpleChanges,
    OnChanges
} from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {

    @Input() currentPage: number;
    @Input() totalPages: number;
    @Input() range = 5;
    @Input() totalNoOfRows: number;
    @Input() currentPageSize: number;
    @Input() pageIndex: number;
    @Input() paginationId: string;
    @Input() showPerPageSize: boolean = false;
    @Output() changeTableSize = new EventEmitter();
    @Output() changePage = new EventEmitter();

    perPageSizes: Object[] = [80,60,40,20];
    totalPagesArr: number[];
    startIndex: number;
    lastIndex: number;
    lastIndexSelected = false;
    displayPagesArray: number[] = [];

    ngOnInit() {
        this.startIndex = 0;
        this.lastIndex = this.range;
        this.initializeDisplayArray(this.currentPage, this.totalPages > this.range ? this.range : this.totalPages);
    }

    private initializeDisplayArray(startIndex: number, range: number) {
        this.displayPagesArray = [];
        for (let i = 0; i < (range); i++) {
            this.displayPagesArray[i] = startIndex++;
        }
    }

    private setStartAndEndIndexesForNext() {
        if (!this.displayPagesArray.includes(this.currentPage)) {
            if (this.currentPage === this.lastIndex + 1 || (this.lastIndex + 1) === this.totalPages) {
                this.startIndex = this.currentPage;
                this.lastIndex = this.currentPage + ((this.totalPages - this.currentPage > this.range)
                    ? this.range - 1 : (this.totalPages - this.currentPage));
                this.initializeDisplayArray(this.currentPage, ((this.totalPages - this.currentPage) > this.range)
                    ? this.range : (this.totalPages - this.currentPage));
            }
            else {
                this.startIndex = this.currentPage;
                this.lastIndex = this.currentPage + ((this.totalPages - this.currentPage > this.range)
                    ? this.range - 1 : (this.totalPages - this.currentPage));
                this.initializeDisplayArray(this.currentPage, ((this.totalPages - this.currentPage) > this.range)
                    ? this.range : (this.totalPages - this.currentPage));
            }
        }
    }

    private setStartAndEndIndexesForPrevious() {
        if (!this.displayPagesArray.includes(this.currentPage)) {
            this.lastIndex = this.currentPage;
            this.startIndex = (this.currentPage - (this.range - 1) < 1 ? 1 : this.currentPage - (this.range - 1));
            this.initializeDisplayArray(this.startIndex, this.range);
        }
    }

    goToPreviousPage() {
        if (this.currentPage !== 1) {
            this.currentPage--;
            this.setStartAndEndIndexesForPrevious();
            this.changePage.emit(this.currentPage);
        }
    }

    goToNextPage() {
        if (this.currentPage !== this.totalPages) {
            this.currentPage++;
            this.setStartAndEndIndexesForNext();
            this.changePage.emit(this.currentPage);
        }
    }

    goToSelectedPage(selectedPage) {
        this.currentPage = selectedPage;
        this.changePage.emit(selectedPage);
    }

    handlePageSizeClick(size: number){
        this.changeTableSize.emit(size);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.totalPages) {
            this.initializeDisplayArray(this.currentPage, this.totalPages > this.range ? this.range : this.totalPages);
        }
    }
}
